// app/javascript/controllers/menu_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav"]

  connect() {
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener("scroll", this.onScroll)
    this.onScroll()

    // モバイルメニュー内リンククリックで閉じる
    this.navTarget.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener("click", () => this.close())
    })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  toggle(event) {
    const button = event.currentTarget

    const isButtonActive = button.classList.toggle("active")
    button.classList.toggle("hamburger--active", isButtonActive)
    button.setAttribute("aria-expanded", String(isButtonActive))

    const isOpen = this.navTarget.classList.toggle("navbar-mobile")
    this.navTarget.classList.toggle("active", isOpen)
    this.navTarget.style.opacity = isOpen ? "1" : ""
    this.navTarget.style.transform = isOpen ? "translateY(0)" : ""
    this.navTarget.style.pointerEvents = isOpen ? "auto" : ""
    document.body.classList.toggle("nav-open", isOpen)
  }

  close() {
    this.navTarget.classList.remove("navbar-mobile")
    this.navTarget.classList.remove("active")
    this.navTarget.style.opacity = ""
    this.navTarget.style.transform = ""
    this.navTarget.style.pointerEvents = ""
    document.body.classList.remove("nav-open")

    const button = this.element.querySelector(".hamburger")

    if (button) {
      button.classList.remove("active")
      button.classList.remove("hamburger--active")
      button.setAttribute("aria-expanded", "false")
    }
  }

  onScroll() {

    const scroll = window.scrollY
    const header = this.element

    // header 縮み
    if (scroll > 80) {
      header.classList.add("header-scrolled")
    } else {
      header.classList.remove("header-scrolled")
    }

    // active nav 更新
    const sections = document.querySelectorAll("section[id]")
    const links = document.querySelectorAll(".nav-link")

    sections.forEach(section => {

      const offset = section.offsetTop - 150
      const height = section.offsetHeight
      const id = section.id

      if (scroll >= offset && scroll < offset + height) {

        links.forEach(link => link.classList.remove("active"))

        const active = document.querySelector(`.nav-link[href="#${id}"]`)

        if (active) {
          active.classList.add("active")
        }

      }

    })
    // reveal animation
    const reveals = document.querySelectorAll(".reveal")

    reveals.forEach(el => {

      const top = el.getBoundingClientRect().top

      if (top < window.innerHeight - 100) {
        el.classList.add("active")
      }

    })
  }
}
